// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Elemental MediaPackage VOD (MEDIAPACKAGE-VOD)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediapackagevod.html
 *
 * 2025-02-24T21:47:54.886Z
 */
export enum AwsMediapackageVodActions {
  /**
   * Grants permission to configure egress access logs for a PackagingGroup
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups-id-configure_logs.html#packaging_groups-id-configure_logsput
   */
  ConfigureLogs = 'mediapackage-vod:ConfigureLogs',
  /**
   * Grants permission to create an asset in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/assets.html#assetspost
   */
  CreateAsset = 'mediapackage-vod:CreateAsset',
  /**
   * Grants permission to create a packaging configuration in AWS Elemental MediaPac
   * kage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_configurations.html#packaging_configurationspost
   */
  CreatePackagingConfiguration = 'mediapackage-vod:CreatePackagingConfiguration',
  /**
   * Grants permission to create a packaging group in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups.html#packaging_groupspost
   */
  CreatePackagingGroup = 'mediapackage-vod:CreatePackagingGroup',
  /**
   * Grants permission to delete an asset in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/assets-id.html#assets-iddelete
   */
  DeleteAsset = 'mediapackage-vod:DeleteAsset',
  /**
   * Grants permission to delete a packaging configuration in AWS Elemental MediaPac
   * kage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_configurations-id.html#packaging_configurations-iddelete
   */
  DeletePackagingConfiguration = 'mediapackage-vod:DeletePackagingConfiguration',
  /**
   * Grants permission to delete a packaging group in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups-id.html#packaging_groups-iddelete
   */
  DeletePackagingGroup = 'mediapackage-vod:DeletePackagingGroup',
  /**
   * Grants permission to view the details of an asset in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/assets-id.html#assets-idget
   */
  DescribeAsset = 'mediapackage-vod:DescribeAsset',
  /**
   * Grants permission to view the details of a packaging configuration in AWS Eleme
   * ntal MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_configurations-id.html#packaging_configurations-idget
   */
  DescribePackagingConfiguration = 'mediapackage-vod:DescribePackagingConfiguration',
  /**
   * Grants permission to view the details of a packaging group in AWS Elemental Med
   * iaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups-id.html#packaging_groups-idget
   */
  DescribePackagingGroup = 'mediapackage-vod:DescribePackagingGroup',
  /**
   * Grants permission to view a list of assets in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/assets.html#assetsget
   */
  ListAssets = 'mediapackage-vod:ListAssets',
  /**
   * Grants permission to view a list of packaging configurations in AWS Elemental M
   * ediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_configurations.html#packaging_configurationsget
   */
  ListPackagingConfigurations = 'mediapackage-vod:ListPackagingConfigurations',
  /**
   * Grants permission to view a list of packaging groups in AWS Elemental MediaPack
   * age
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups.html#packaging_groupsget
   */
  ListPackagingGroups = 'mediapackage-vod:ListPackagingGroups',
  /**
   * Grants permission to list the tags assigned to a PackagingGroup, PackagingConfi
   * guration, or Asset
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/tags-resource-arn.html#tags-resource-arnget
   */
  ListTagsForResource = 'mediapackage-vod:ListTagsForResource',
  /**
   * Grants permission to assign tags to a PackagingGroup, PackagingConfiguration, o
   * r Asset
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/tags-resource-arn.html#tags-resource-arnpost
   */
  TagResource = 'mediapackage-vod:TagResource',
  /**
   * Grants permission to delete tags from a PackagingGroup, PackagingConfiguration,
   * or Asset
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/tags-resource-arn.html#tags-resource-arndelete
   */
  UntagResource = 'mediapackage-vod:UntagResource',
  /**
   * Grants permission to update a packaging group in AWS Elemental MediaPackage
   *
   * See https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/packaging_groups-id.html#packaging_groups-idput
   */
  UpdatePackagingGroup = 'mediapackage-vod:UpdatePackagingGroup',
}
